import ApiService from "./api.service";
import mainStore from "../store/mainStore";

class RoomMapService extends ApiService {
    // ========== ZONES (Strefy) ==========
    getZones(roomMapId) {
        return this.get(`api/management/room-map/${roomMapId}/zones`);
    }

    addZone(roomMapId, zoneData) {
        return this.post(`api/management/room-map/${roomMapId}/zones`, zoneData);
    }

    updateZone(roomMapId, zoneId, zoneData) {
        return this.post(`api/management/room-map/${roomMapId}/zones/${zoneId}`, zoneData);
    }

    deleteZone(roomMapId, zoneId) {
        return this.delete(`api/management/room-map/${roomMapId}/zones/${zoneId}`);
    }

    // ========== MICROPHONES ON MAP ==========
    getMicrophones(roomMapId) {
        return this.get(`api/management/room-map/${roomMapId}/microphones`);
    }

    addMicrophone(roomMapId, micData) {
        return this.post(`api/management/room-map/${roomMapId}/microphones`, micData);
    }

    updateMicrophone(roomMapId, micId, micData) {
        return this.post(`api/management/room-map/${roomMapId}/microphones/${micId}`, micData);
    }

    deleteMicrophone(roomMapId, micId) {
        return this.delete(`api/management/room-map/${roomMapId}/microphones/${micId}`);
    }

    // ========== USERS FOR MICROPHONES ==========
    getUsersForMicrophones(roomMapId) {
        return this.get(`api/management/room-map/${roomMapId}/users-for-mics`);
    }

    assignUserToMicrophone(roomMapId, micId, userId) {
        return this.post(`api/management/room-map/${roomMapId}/microphones/${micId}/users/${userId}`);
    }

    removeUserFromMicrophone(roomMapId, micId, userId) {
        return this.delete(`api/management/room-map/${roomMapId}/microphones/${micId}/users/${userId}`);
    }

    getAllMicrophoneUsers(roomMapId) {
        return this.get(`api/management/room-map/${roomMapId}/microphones-users`);
    }

    // ========== Rooms Maps ==========
    async GetAll() {
        let response = await this.get("api/management/room-map/rooms-maps");
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }
        mainStore.commit('roomMap/setAvailableRoomMaps', response.data)
    }

    async Delete(id) {
        let response = await this.delete(`api/management/room-map/delete-room-map/${id}`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }
        await this.GetAll();
    }

    async Create(data) {
        let response = await this.post("api/management/room-map/add-room-map", data);

        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await this.GetAll();
    }

    async Update(id, data) {
        let response = await this.put(`api/management/room-map/update-room-map/${id}`, data);

        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await this.GetAll();
    }

    // ========== ROOM MAP FOR SESSION ==========
    setRoomMapForSession(roomMapId, sessionId) {
        return this.post(`api/management/room-map/set-room-map/${roomMapId}/session/${sessionId}`);
    }

    removeRoomMapForSession(sessionId) {
        return this.post(`api/management/room-map/delete-room-map/session/${sessionId}`);
    }

    getRoomMapForSession(sessionId) {
        return this.get(`api/management/room-map/session/${sessionId}`);
    }

    checkClientRoomMapForSession(roomId, sessionId) {
        return this.get(`api/management/room-map/${roomId}/check/session/${sessionId}`);
    }

    // ========== Update mic-user pairs in interactive ==========
    getMicUserPair(roomMapId) {
        return this.get(`api/management/room-map/${roomMapId}/interactive/uptade-mic-user-pair`);
    }
}

export default new RoomMapService();

